<template>
  <div class="multi-search-date flexC mr-8">
    <div  v-if="config.title" class="option-title mr-6">
      {{ config.title }}
    </div>
    <cube-date-picker
      v-model="form.value"
      class="mr-8"
      v-bind="config"
      :value-format="valueFormat"
      @change="change"
      @clear="clear"
    >
    </cube-date-picker>
  </div>
</template>
<script>
export default {
  props: {
    parent: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      form: {
        value: ''
      }
    }
  },
  computed: {
    config() {
      return this.parent.config ? this.parent.config : {}
    },
    valueFormat() {
      return this.config.valueFormat ? this.config.valueFormat : 'yyyy-MM-dd'
    }
  },

  methods: {
    change() {
      this.confirm()
    },
    clear() {
      this.$emit('clear', 'datePick')
    },
    reset() {
      this.form.value = []
    },
    confirm() {
      if (!this.form.value || !this.form.value.length) {
        this.clear()
        return
      }
      const tagLabel = this.config.title // this.option[label]
      const tagValue = this.form.value// this.option[value]
      this.$emit(
        'confirm',
        this.parent,
        { label: tagLabel, value: tagValue },
        'datePick'
      )
      // this.form.value = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.option-title {
  font-size: 14px;
  color: #686f80;
}
</style>
